import React, { useEffect, useState } from "react";
import Images from "../../Component/Simage";
import { GetAllCmsData } from "../../Hooks/UseBackend";
function Banner() {
  const [CmsData, setCmsData] = useState([]);
  const [section1, setsection1] = useState();
  useEffect(() => {
    getCmsData();
  }, []);


  const getCmsData = async () => {
    console.log("enterthis");
    let res = await GetAllCmsData();

    if (res.data) {
      setsection1(res.data.find((value) => (value.identifier == 'Storage Page')))
    }


    setCmsData(res.data);
  };
  return (
    <div className="storage_banner position-relative">
      <div className="banner_bg">
        <video autoPlay muted loop className="video_src img-fluid">
          <source src={Images.storage_banner_bg} type="video/mp4" />
        </video>
      </div>
      <div className="content_sec">
        {console.log("section1section1", section1)}

        <h1 className="title-txt text-center fw-600 mb-3 mb-xxl-4">
          {section1 && section1?.Title}        </h1>
        <h6 className="section-videoBanner__content-desc">
          {section1 && section1?.Content}
        </h6>
      </div>
    </div>
  );
}

export default Banner;
